// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + "home" + "." + "657f52dabcca74ebe7fb" + ".css";
};